
import { Component, Prop, Watch, Vue, Emit } from "vue-property-decorator";
import vSelect from "vue-select";
import { validationMixin } from "vuelidate";
import {
	required,
	minLength,
} from "vuelidate/lib/validators";
import { renderChoiceEnum } from "@/models/Tasks/renderType";
import { ActionPlanTask } from "../../../store/tasks/types";
import { tryParseJson } from "@/filters";

@Component({
	components: {
		"vue-select": vSelect
	},
	mixins: [validationMixin],
	filters: { tryParseJson },
	validations: {
		choicesData: {
			choiceDescription: {
				required
			},
			choiceOptions: {
				required,
				minLength: minLength(2),
				$each: {
					required
				}
			}
		}
	}
})
export default class ChoicesTaskSetup extends Vue {
	@Prop() public value!: ActionPlanTask;

	private choiceListTypes: string[] = [];

	public choicesData: any = {
		choiceDescription: "",
		choiceOptions: ["", ""],
		selectedChoice: renderChoiceEnum.Listbox
	};

	public mounted() {
		// Get types from Enum and put them within choicesList string array. Couldn't directly use enum within template
		for (let item in renderChoiceEnum) {
			this.choiceListTypes.push(item);
		}

		this.loadFromTask();
		this.onValidationChange(this.$v.$invalid);
	}

	/** Watcher, when data changes within 'ChoicesData' call 'ChoicesSettingsChange'*/
	@Watch("choicesData", { deep: true, immediate: true })
	public onChoicesSettingsChange(newValue) {
		this.$v.$touch();

		if (!this.$v.$error) {
			this.onInput();
		}
	}

	/**
	 * Fires an input event containing the new task.
	 */
	@Emit("input")
	private onInput() {
		return {
			...this.value,
			taskText: this.choicesData.choiceDescription,
			taskData: {
				...this.choicesData
			}
		};
	}

	/**
	 * Updates a choice option. Uses $set because Vue 2 cannot observe an
	 * array element assigned by index, which would otherwise skip the
	 * choicesData watcher and leave the parent's Save button disabled.
	 */
	private onOptionInput(i: number, value: string): void {
		this.$set(this.choicesData.choiceOptions, i, value);
	}

	/**
	 * Watcher/emitter for the validation state of this component,
	 * bubbles up vuelidate's validation state when it changes.
	 */
	@Watch("$v.$invalid")
	private onValidationChange($invalid: boolean) {
		this.$emit("validate-task", !$invalid);
	}

	/**
	 * Loads the choice data from the current task
	 */
	private loadFromTask(): void {
		if (this.value?.taskData != null) {
			let taskData = this.value?.taskData || {};

			// If taskData is a string, try to parse it as JSON.
			if (taskData && typeof taskData === "string") {
				taskData = tryParseJson(taskData) || {};
			} else if (taskData && typeof taskData !== "object") {
				taskData = {};
			}

			// Clone choiceOptions so option edits mutate this component's own array,
			// not the pristine task the parent compares against to enable Save.
			this.choicesData = {
				...taskData,
				choiceOptions: Array.isArray(taskData.choiceOptions)
					? [...taskData.choiceOptions]
					: []
			};
		}
	}
}
